import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',

    '&:before': {
      content: 'none',
    },

    '& .content': {
      display: 'flex',
      flexDirection: 'row',
      textAlign: 'left',
      width: '100%',
      minHeight: theme.spacing(8),
      padding: theme.spacing(1, 2),
      margin: theme.spacing(0),

      '&:hover': {
        backgroundColor: theme.palette.custom.surface[1],
      },

      '&-children': {
        padding: theme.spacing(0),
        flexDirection: 'column',
      },
    },

    '& .progress': {},

    '& .text-wrapper': {
      flexGrow: 1,
      padding: `0 ${theme.spacing(1)}px`,

      '& .title.completed': {
        color: theme.palette.custom.feedback.positive,
      },
    },

    '& .amount': {
      color: theme.palette.text.hint,
    },

    '& .icon': {
      color: theme.palette.text.hint,
    },

    '& .empty-module': {
      padding: `0 ${theme.spacing(2)}px 0 ${theme.spacing(7)}px`,
      height: theme.spacing(6),
      display: 'flex',
      alignItems: 'center',

      '&-text': {
        color: theme.palette.text.disabled,
      },
    },
  },
  expanded: {
    margin: theme.spacing(0),
  },
  content: {
    margin: theme.spacing(0),
    alignItems: 'center',

    '&$expanded': {
      margin: theme.spacing(0),
    },
  },
}));

export default styles;
